import numeral from 'numeral';

export const DecimalFormat = (amount: any) => {
    let value: string = '0.00';
    if (amount) {
        value = numeral(amount).format('0,0.00');
    } 
    return value;
};
